/**
 * Save a PDF the API answered with as base64 — `{ pdf, filename }`, the shape
 * every PDF endpoint here returns (vouchers, service offers, the Month End
 * operator report) — through a temporary download link.
 *
 * One copy, because there were two identical ones (VoucherService,
 * ServiceOfferService) before the Month End report needed a third.
 *
 * @param {{ pdf?: string, filename?: string }} result the API's answer
 * @param {string} fallbackFilename used when the answer names no file
 * @throws {Error} when the answer carries no PDF
 */
export default function downloadPdf(result, fallbackFilename = 'document.pdf') {
  if (!result?.pdf) throw new Error('Failed to generate PDF');

  const link = document.createElement('a');
  link.href = `data:application/pdf;base64,${result.pdf}`;
  link.download = result.filename || fallbackFilename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
